import React from "react";
import "./JobAds.css";
import { useState, useEffect } from "react";
import adsStyle from "./JobsAds.module.css";
import appURLs from "../../../appURL";
import getFetchConfig from "../../../utils/getFetchConfig";
import getSymbolFromCurrency from "currency-symbol-map";
import SimpleImageSlider from "react-simple-image-slider";
import FeaturedImage from "../../../assest/images/Room for rent 3.png";
import CommonModalWrapper from "../../common-modal-Wrapper/CommonModalWrapper";
import AdsPlans from "../../postAds/ads-plans/AdsPlans";
import CloseIcon from "../../Icons/CloseIcon";
import { toast } from "react-toastify";
import SocialMediaLink from "../../socialMediaLink/socialMediaLink";
import dotImage from "../../../assest/images/my_add_menu.svg";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";
import TransferModal from "../../Modals/TransferModal";

function JobAdsComp({
  item,
  index,
  transfer,
  featureStatus,
  getTimeSinceCreation,
  setcheckJobEdit,
  status_detail,
  rentAdsData,
  setRentAdsData,
  setadsIds,
}) {
  const fetchConfig = getFetchConfig(),
    appURL = appURLs();
  const navigate = useNavigate();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [showAdsPlan, setShowAdsPlan] = useState(false);
  const [myads_id, setmyads_id] = useState('');
  const [showTransfer, setShowTransfer] = useState(false)

  const titlebtn = (id) => {
    if (item.status !== "draft") {
      navigate(`/jobDetails/${id}`)
    }
  };

  function stopRedirect(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  function openModal() {
    if (status_detail !== "expired") {
      setIsOpen(true);
    }
  }

  function closeModal(event) {
    if(event){
      event.preventDefault();
      event.stopPropagation();
    }
    setIsOpen(false);
  }

  const handlePromoteClick = (id) => {
    // Set showAdsPlan to true to show the AdsPlan component
    setShowAdsPlan(true);
    // fetchAdDetails();
  };

  const closeThisModal = (toggleValue = false, event) => {
    setIsOpen(false);
    event.stopPropagation();
    setShowAdsPlan(toggleValue);
  };

  useEffect(() => {
    // console.log("modalIsOpen", modalIsOpen);
  }, [modalIsOpen])

  function formatDate(dateString) {
    const options = { month: "2-digit", day: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString(undefined, options);
    return formattedDate;
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      background: `rgba(0, 0, 0, 0.4)`,
      zIndex: 1,
    },
  };

  const handleTransferClick = (id) => {
    setShowTransfer(true);
  };

  const closeTransferModal = (toggleValue = false, event) => {
    event.stopPropagation();
    setShowTransfer(toggleValue);
  };

  const editFunctionality = (event,id) => {
    event.stopPropagation();
    setIsOpen(false);
    setcheckJobEdit((prevCheckJobEdit) => !prevCheckJobEdit);
    setadsIds(id);
    localStorage.setItem("new_my_id", id);
    setIsOpen(false);
  };

  const deleteFunctionality = async (event,id) => {
    event.stopPropagation();
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await fetch(`${appURL}/posts/jobs/remove?ads_id=${id}`, {
        ...fetchConfig,
        method: "PATCH",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      const data = rentAdsData.filter((data) => data._id != id);
      setRentAdsData(data);
      toast.success("Ads deleted Successfully");
      setIsOpen(false);

      // Update state or perform any other necessary actions after deletion
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <>
      <div
        key={index}
        className="tab_details_wrap"
        onClick={() => {
          titlebtn(item._id);
        }}
      >
        <div className="ad_details_image_main">
          {Array.isArray(item.adsInfo?.image) &&
            item.adsInfo.image.length > 0 ? (
            // <div>
            //   <SimpleImageSlider
            //     width={140}
            //     height={140}
            //     images={item.adsInfo.image.map((info) => info.url)}
            //     showNavs={item.adsInfo.image.length > 1 ? true : false}
            //     showBullets={item.adsInfo.image.length > 1 ? true : false}
            //   />
            // </div>
            <img src={item.adsInfo.image[0].url} alt="Dummy" />
          ) : (
            <img src={FeaturedImage} alt="Dummy" />
          )}


          {item.status === 'active' ?
            <div className="featured_label_set">
              {item.addons_validity.some(
                (addon) => addon.name === "Featured" && new Date(addon.expired_on) >= new Date()
              )?(
                <svg
                  width="91"
                  height="26"
                  viewBox="0 0 91 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="0.935547"
                    width="91"
                    height="25"
                    rx="4"
                    fill="#F07639"
                  />
                  <path
                    d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                    fill="#ffffff"
                  />
                </svg>
              ) : (
                ""
              )}
            </div>
            : ""}

          {item.status === "active" || item.status === "draft" ? (
            <>
              <div style={{ width: "30px" }} className="dots_set"
               onClick={(e) => {
                e.stopPropagation();
                openModal();
               }}>
                <img src={dotImage} alt="" />
              </div>

              <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
                onClick={(e) => e.stopPropagation()}
              >
                {/* <div className={adsStyle.ads_mod}> */}
                <div className={adsStyle.ads_mod} onClick={(e) => e.stopPropagation()}>
                  <button
                    className={adsStyle.close_button}
                    // onClick={closeModal}
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); closeModal(e); }}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                  <div className={adsStyle.fav_pop_up}>
                    <ul>
                      <li
                        key={index}
                        onClick={(e) => editFunctionality(e,item._id)}
                      >
                        Edit
                      </li>
                      <li
                        key={index}
                        onClick={(e) => deleteFunctionality(e,item._id)}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </div>
              </Modal>
            </>
          ) : (
            ""
          )}
        </div>

        <div className="complete_div">

          <div className="title_set" onClick={stopRedirect}>
            {item.adsInfo.title && <h3>{item.adsInfo.title}</h3>}

            <button className={`button_status ${item.status}`}>
              {item.status === 'inactive' ? 'expired' : item.status}
            </button>
          </div>

          <div className="den_div">
            {item.adsInfo.descriptions && <p>{item.adsInfo.descriptions}</p>}

            {item.adsInfo.location.location_name && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="fa-solid fa-location-dot"></i> &nbsp;
                <p>{item.adsInfo.location.location_name}</p>
              </div>
            )}
          </div>

          <div className="price_amount">
            <p>
              {item.adsInfo.salary.amount &&
                item.adsInfo.salary.amount !== 0 ? (
                <>
                  {item.adsInfo.salary.currency &&
                    getSymbolFromCurrency(item.adsInfo.salary.currency)}
                  {item.adsInfo.salary.amount}
                  {item.adsInfo.salary_info && ` ${item.adsInfo.salary_info}`}
                </>
              ) : (
                item.adsInfo.salary.amount === 0 && "FREE"
              )}
            </p>
          </div>

          {item.adsInfo.image && (
            <img src="/src/assets/image 6 (2).png" alt="" />
          )}


          {item.status === 'active' ?
            <div className="text_div">
              {/* show price logic */}

              <div className="text_right">
                <div className="urgent_label">
                  {item.addons_validity.some(
                    (addon) => addon.name === "Urgent" && new Date(addon.expired_on) >= new Date()
                  ) && <button>Urgent</button>}
                </div>

                <div className="upcoming_label">
                  {item.addons_validity.some(
                    (addon) => addon.name === "Upcoming event"
                  ) && <button>Upcoming event</button>}
                </div>
              </div>
            </div>
            : ""}

          <div className="listed_by">
            {item.status !== 'draft' && (
              <p>
                Listed on:{" "}
                <span style={{ fontSize: "13px" }}>
                  {getTimeSinceCreation(
                    item.active_on_virtual,
                    item.location_timezone
                  )}
                </span>
              </p>
            )}

            {item.status === 'draft' && (
              <p>
                Listed on:{" "}
                <span style={{ fontSize: "13px" }}>
                  {getTimeSinceCreation(item.createdAt)}
                </span>
              </p>
            )}

            <p>
              {item.status === "active" || item.status === "draft" ? (
                <>
                  Active until:{" "}
                  <span style={{ fontSize: "13px" }}>
                    {item.plan_validity && item.plan_validity.expired_on
                      ? formatDate(item.plan_validity.expired_on)
                      : "No expiration date"}
                  </span>
                </>
              ) : item.status === "deleted" ? (
                <>
                  Ad deleted date:{" "}
                  <span style={{ fontSize: "13px" }}>
                    {item.deletedAt ? formatDate(item.deletedAt) : ""}
                  </span>
                </>
              ) : item.status === "inactive" ? (
                <>
                  Ad expired date:{" "}
                  <span style={{ fontSize: "13px" }}>
                    {item.plan_validity && item.plan_validity.expired_on
                      ? formatDate(item.plan_validity.expired_on)
                      : "No expiration date"}
                  </span>
                </>
              ) : null}
            </p>
          </div>
        </div>


        {/* {item.adsType.name} */}

        <div className="view_counts_promo">
          <div className="view_counts">
            <div className="heart_count">
              <svg
                width="23"
                height="21"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6066 4.13581C9.60726 1.7984 6.27321 1.16964 3.76816 3.31001C1.26311 5.45038 0.910432 9.02898 2.87766 11.5604C4.51328 13.6651 9.46324 18.1041 11.0856 19.5408C11.2671 19.7016 11.3578 19.7819 11.4637 19.8135C11.5561 19.8411 11.6572 19.8411 11.7496 19.8135C11.8554 19.7819 11.9462 19.7016 12.1277 19.5408C13.75 18.1041 18.6999 13.6651 20.3356 11.5604C22.3028 9.02898 21.9932 5.42787 19.4451 3.31001C16.897 1.19216 13.606 1.7984 11.6066 4.13581Z"
                  stroke="#A9A8B3"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {item.favoriteCount}
            </div>

            <div className="heart_count">
              <svg
                width="25"
                height="18"
                viewBox="0 0 25 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.3064 7.90968C23.8506 8.62284 23.8506 9.58561 23.3064 10.2976C21.5921 12.5395 17.4793 17.1555 12.6775 17.1555C7.87577 17.1555 3.76293 12.5395 2.04867 10.2976C1.78388 9.95615 1.64014 9.53606 1.64014 9.10365C1.64014 8.67125 1.78388 8.25116 2.04867 7.90968C3.76293 5.66782 7.87577 1.05182 12.6775 1.05182C17.4793 1.05182 21.5921 5.66782 23.3064 7.90968V7.90968Z"
                  stroke="#C9C9C9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.6776 12.5544C14.58 12.5544 16.1222 11.0094 16.1222 9.10362C16.1222 7.1978 14.58 5.65283 12.6776 5.65283C10.7752 5.65283 9.23297 7.1978 9.23297 9.10362C9.23297 11.0094 10.7752 12.5544 12.6776 12.5544Z"
                  stroke="#C9C9C9"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {item.viewCount ? item.viewCount : ""}
            </div>
          </div>

          <div className="promotion">

            {item.status === 'deleted' || item.status === 'inactive' ?
              <div
                key={index}
                onClick={(event) => {
                  // editFunctionality(item._id);
                   editFunctionality(event, item._id);
                  stopRedirect(event);
                }}
              >
                <button className="respost_btn">Repost</button>
              </div>
              :
              ""
            }

            <div className="d-flex gap-2">
              {transfer && (
                <button
                  className="transfer_btn"
                  key={index}
                  onClick={(event) => {
                    stopRedirect(event);
                    handleTransferClick(item._id);
                  }}
                >
                  Transfer
                </button>
              )}
              {item.status === "active" && (
                <button
                  className="respost_btn"
                  key={index}
                  onClick={(event) => {
                    stopRedirect(event);
                    handlePromoteClick(item._id);
                  }}
                >
                  Promote
                </button>
              )}
            </div>

          </div>

        </div>
      </div>

      {showAdsPlan && (
        <CommonModalWrapper
          isOpen={true}
          className="room_rents_modal_wrapper"
        >
          <CloseIcon onClick={(event) => closeThisModal(false, event)} />
          <AdsPlans
            adsId={item._id}
            adsCategoriesId={item.adsType}
            category={"jobs"}
            myads_id={myads_id}
            showAdsPlan={showAdsPlan}
            setShowAdsPlan={setShowAdsPlan}
          />
        </CommonModalWrapper>
      )}

      {showTransfer && (
        <CommonModalWrapper
          isOpen={true}
          className="room_rents_modal_wrapper"
        >
          <CloseIcon onClick={(event) => closeTransferModal(false, event)} />
          <TransferModal
            adsId={item._id}
          />
        </CommonModalWrapper>
      )}
    </>
  );
}

export default JobAdsComp;
